import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { toast } from "sonner";

const LABEL = { connected: "QZ conectado", connecting: "Conectando QZ…", offline: "QZ sin conexión" };
const DOT = { connected: "bg-[#22C55E]", connecting: "bg-[#F59E0B] animate-pulse", offline: "bg-[#DC2626]" };

export const QzStatus = () => {
  const [state, setState] = useState("unknown");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    import("../lib/qz").then((m) => setState(m.getQzState()));
    const on = (e) => setState(e.detail);
    window.addEventListener("qz-status", on);
    return () => { window.removeEventListener("qz-status", on); };
  }, []);
  if (state === "unknown") return null;
  const reconnect = async () => {
    setBusy(true);
    try { const { reconnectQz } = await import("../lib/qz"); await reconnectQz(); toast.success("QZ Tray conectado"); }
    catch (e) { toast.error("No se pudo conectar con QZ Tray. Revisa que esté abierto en este equipo."); }
    finally { setBusy(false); }
  };
  return (
    <div className="flex items-center gap-2 px-2 py-1.5 rounded-lg bg-white/10 text-xs" data-testid="qz-status">
      <span className={`w-2.5 h-2.5 rounded-full ${DOT[state]}`} />
      <span className="flex-1 min-w-0 truncate whitespace-nowrap font-semibold" data-testid="qz-status-text">{LABEL[state]}</span>
      {state !== "connected" && (
        <button data-testid="qz-reconnect-btn" onClick={reconnect} disabled={busy} className="shrink-0 flex items-center gap-1 px-2 h-6 rounded-md bg-white/20 hover:bg-white/30 font-semibold disabled:opacity-60">
          <RefreshCw size={12} className={busy ? "animate-spin" : ""} /> Reconectar
        </button>
      )}
    </div>
  );
};
